<mat-menu #menu="matMenu" panelClass="dropdown-menu">

  <button
    class="dropdown-menu__item"
    *ngFor="let item of items"
    mat-menu-item
    [disabled]="item.disabled"
    [routerLink]="item.route"
    (click)="onItemClick(item)">

    <mat-icon *ngIf="item.icon" class="dropdown-menu__item-icon">
      {{ item.icon }}
    </mat-icon>

    <atom-label class="dropdown-menu__item-label" [text]="item.label"></atom-label>

  </button>
</mat-menu>

<button
  mat-button
  class="dropdown-menu__trigger"
  [matMenuTriggerFor]="menu">

  <span class="dropdown-menu__trigger-group">
    <mat-icon>{{ icon }}</mat-icon>
    {{ label }}
  </span>

</button>
